// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"component-loader_sectionWrapper__20ewY","componentLoader":"component-loader_componentLoader__1ZkSu"};